const merge = require("lodash").merge;

const { hostInfo, applyRegionalConfig } = require("./envUtils");
const { isChina, withRuntimeCommons } = require("./runtimeCommons");

// config to hold the final merged configuration
let config = null;
if (process.env.PLATFORM_ENV === "url") {
  const platformEnv = hostInfo.platformEnv;

  // get and decode the encoded config index
  // This encoded index is generated during the build process (check the build script in package.json)
  // It contains all environment configurations in a base64 encoded JSON string
  const encodedIndex = require("./index.encod.json");
  const decodedIndexJson = Buffer.from(encodedIndex, "base64").toString("utf8");
  const configMap = JSON.parse(decodedIndexJson);

  const defaultsConfig = configMap.defaults;
  const envConfig = configMap[platformEnv];
  if (!envConfig) {
    throw new Error(`No config found for platformEnv=${platformEnv}`);
  }

  config = merge({}, defaultsConfig, envConfig);
} else {
  const envConfig = require(`./${process.env.PLATFORM_ENV || "staging"}.json`);
  const defaultsJson = require("./defaults.json");
  config = merge({}, defaultsJson, envConfig);
}

// apply regional overrides based on isChina and flatten them to top-level
config = applyRegionalConfig(config, isChina);

// attach commonly used helpers and flags to the final config object
module.exports = withRuntimeCommons(config);
